import script from "./BasicInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicInfo.vue?vue&type=script&setup=true&lang=js"

import "./BasicInfo.vue?vue&type=style&index=0&id=20ebe8d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ebe8d6"]])

export default __exports__